'use strict'
// 引入vue和axios
import Vue from 'vue'
import axios from 'axios'
import md5 from 'js-md5'
import router from '../router'

import {
  serveUrl,
  getConfig,
  postConfig,
} from './config'
import {config as myConfig} from '../config'
import {getHomeData, updateNewsAuditStatus} from "../vuex/actions";

// 继承vue的原型方法
Vue.prototype.axios = axios
const service = axios.create({
  baseURL: '/api',
  // baseURL: '/',
  timeout: 10000
})

// 开发环境调试用户信息
service.interceptors.request.use(config => {
  if (process.env.NODE_ENV === 'development') {
    // config.headers['username'] = 'test'
  }
  let time = new Date().getTime()
  config.headers.Time = time
  config.headers.Auth = md5(time + myConfig.api_secret + time)
  return config
})

service.interceptors.response.use(
  response => {
    let data = response.data
    if (!data.data) {
      //   登陆成功的回调地址
      return data
    } else {
      return data
    }
  },
  error => ({
    code: -1,
    msg: '网络异常'
  })
)

export default {
  // api
  getUserInfo: params => {
    return service.post('/home/user/queryuser', params)
  },
  getUser: params => {
    return service.get('/home/user/getUser', {params: params})
  },
  getSearchUser: params => {
    return service.get('/home/user/getSearchUser', {params: params})
  },
  createUser: params => {
    return service.post('/home/user/createUser', params)
  },
  updateUser: params => {
    return service.post('/home/user/updateUser', params)
  },
  resetUserPwd: params => {
    return service.post('/home/user/resetUserPwd', params)
  },
  unlockUser: params => {
    return service.post('/home/user/unlockUser', params)
  },
  cleanUser: params => {
    return service.post('/home/user/cleanUser', params)
  },
  login: params => {
    return service.post('/home/user/login', params)
  },
  logout: params => {
    return service.post('/home/user/logout', params)
  },
  changePassword: params => {
    return service.post('/home/user/changepass', params)
  },
  updateProfile: params => {
    return service.post('/home/user/updateProfile', params)
  },
  createChannel: params => {
    return service.post('/home/channel/createChannel', params)
  },
  updateChannel: params => {
    return service.post('/home/channel/updateChannel', params)
  },
  getChannel: params => {
    return service.get('/home/channel/getChannel', {params: params})
  },
  getChannels: params => {
    return service.get('/home/channel/getChannels', {params: params})
  },
  createNews: params => {
    return service.post('/home/news/createNews', params)
  },
  createChain: params => {
    return service.post('/home/news/createChain', params)
  },
  updateChain: params => {
    return service.post('/home/news/updateChain', params)
  },
  delChain: params => {
    return service.post('/home/news/delChain', params)
  },
  delPlans: params => {
    return service.post('/home/news/delPlans', params)
  },
  updateNews: params => {
    return service.post('/home/news/updateNews', params)
  },
  pubNews: params => {
    return service.post('/home/news/pubNews', params)
  },
  revokeNews: params => {
    return service.post('/home/news/revokeNews', params)
  },
  deleteNews: params => {
    return service.post('/home/news/deleteNews', params)
  },
  getNewsList: params => {
    return service.get('/home/news/getNewsList', {params: params})
  },
  getPlansNewsList: params => {
    return service.get('/home/news/getPlansNewsList', {params: params})
  },
  getRevokeNewsList: params => {
    return service.get('/home/news/getRevokeNewsList', {params: params})
  },
  getSearchNews: params => {
    return service.get('/home/news/getSearchNews', {params: params})
  },
  getNews: params => {
    return service.get('/home/news/getNews', {params: params})
  },
  getNewsLogs: params => {
    return service.get('/home/news/getNewsLogs', {params: params})
  },
  updateNewsWeight: params => {
    return service.post('/home/news/updateNewsWeight', params)
  },
  updateNewsAuditStatus: params => {
    return service.post('/home/news/updateNewsAuditStatus', params)
  },
  updateNewsVoteNums: params => {
    return service.post('/home/news/updateNewsVoteNums', params)
  },
  createNewsSignature: params => {
    return service.post('/home/news/createNewsSignature', params)
  },
  delNewsSignature: params => {
    return service.post('/home/news/delNewsSignature', params)
  },
  getNewsSignsByKey: params => {
    return service.post('/home/signature/getNewsSignsByKey', params)
  },
  createRelate: params => {
    return service.post('/home/news/createRelate', params)
  },
  delRelate: params => {
    return service.post('/home/news/delRelate', params)
  },
  updateNewsRelateWeight: params => {
    return service.post('/home/news/updateNewsRelateWeight', params)
  },
  getSearchRelateNews: params => {
    return service.get('/home/news/getSearchRelateNews', {params: params})
  },
  getRelateNews: params => {
    return service.get('/home/news/getRelateNews', {params: params})
  },
  createNewsPlan: params => {
    return service.post('/home/news/createNewsPlan', params)
  },
  createNewsVote: params => {
    return service.post('/home/news/createNewsVote', params)
  },
  updateNewsVote: params => {
    return service.post('/home/news/updateNewsVote', params)
  },
  pushUrlToCdn: params => {
    return service.post('/home/news/pushUrlToCdn', params)
  },
  pushSolr: params => {
    return service.post('/home/news/pushSolr', params)
  },
  upload: params => {
    return service.post('/home/news/upload', params)
  },
  getNewsVotes: params => {
    return service.get('/home/news/getNewsVotes', {params: params})
  },
  getNewsVote: params => {
    return service.get('/home/news/getNewsVote', {params: params})
  },
  getAutoKeyword: params => {
    return service.post('/home/news/autoKeyword', params)
  },
  createSignature: params => {
    return service.post('/home/signature/createSignature', params)
  },
  updateSignature: params => {
    return service.post('/home/signature/updateSignature', params)
  },
  getSignatures: params => {
    return service.get('/home/signature/getSignatures', {params: params})
  },
  getSignature: params => {
    return service.get('/home/signature/getSignature', {params: params})
  },
  getApps: params => {
    return service.get('/home/app/getApps', {params: params})
  },
  getApp: params => {
    return service.get('/home/app/getApp', {params: params})
  },
  createApp: params => {
    return service.post('/home/app/createApp', params)
  },
  updateApp: params => {
    return service.post('/home/app/updateApp', params)
  },
  getSearchReg: params => {
    return service.get('/home/reg/getSearchReg', {params: params})
  },
  getReg: params => {
    return service.get('/home/reg/getReg', {params: params})
  },
  createReg: params => {
    return service.post('/home/reg/createReg', params)
  },
  adminUpdateRegPwd: params => {
    return service.post('/home/reg/adminUpdateRegPwd', params)
  },
  updateRegStatus: params => {
    return service.post('/home/reg/updateRegStatus', params)
  },
  createCourseCategory: params => {
    return service.post('/home/coursecategory/createCourseCategory', params)
  },
  updateCourseCategory: params => {
    return service.post('/home/coursecategory/updateCourseCategory', params)
  },
  getCourseCategory: params => {
    return service.get('/home/coursecategory/getCourseCategory', {params: params})
  },
  getCourseCategoryList: params => {
    return service.get('/home/coursecategory/getCourseCategoryList', {params: params})
  },
  createCourse: params => {
    return service.post('/home/course/createCourse', params)
  },
  updateCourse: params => {
    return service.post('/home/course/updateCourse', params)
  },
  getCourse: params => {
    return service.get('/home/course/getCourse', {params: params})
  },
  getCourseList: params => {
    return service.get('/home/course/getCourseList', {params: params})
  },
  updateCourseStatus: params => {
    return service.post('/home/course/updateCourseStatus', params)
  },
  updateCourseIsBest: params => {
    return service.post('/home/course/updateCourseIsBest', params)
  },
  updateCourseChapter: params => {
    return service.post('/home/coursechapter/updateCourseChapter', params)
  },
  getCourseChapter: params => {
    return service.get('/home/coursechapter/getCourseChapter', {params: params})
  },
  getCourseChapterList: params => {
    return service.get('/home/coursechapter/getCourseChapterList', {params: params})
  },
  updateCourseChapterStatus: params => {
    return service.post('/home/coursechapter/updateCourseChapterStatus', params)
  },
  createCourseFile: params => {
    return service.post('/home/coursefile/createCourseFile', params)
  },
  updateCourseFile: params => {
    return service.post('/home/coursefile/updateCourseFile', params)
  },
  getCourseFile: params => {
    return service.get('/home/coursefile/getCourseFile', {params: params})
  },
  getCourseFileList: params => {
    return service.get('/home/coursefile/getCourseFileList', {params: params})
  },
  updateCourseFileStatus: params => {
    return service.post('/home/coursefile/updateCourseFileStatus', params)
  },
  createCourseComment: params => {
    return service.post('/home/coursecomment/createCourseComment', params)
  },
  updateCourseComment: params => {
    return service.post('/home/coursecomment/updateCourseComment', params)
  },
  getCourseComment: params => {
    return service.get('/home/coursecomment/getCourseComment', {params: params})
  },
  getCourseCommentList: params => {
    return service.get('/home/coursecomment/getCourseCommentList', {params: params})
  },
  updateCourseCommentStatus: params => {
    return service.post('/home/coursecomment/updateCourseCommentStatus', params)
  },
  getCourseQuestion: params => {
    return service.get('/home/coursequestion/getCourseQuestion', {params: params})
  },
  getCourseQuestionList: params => {
    return service.get('/home/coursequestion/getCourseQuestionList', {params: params})
  },
  replyCourseQuestion: params => {
    return service.post('/home/coursequestion/replyCourseQuestion', params)
  },
  createCourseTask: params => {
    return service.post('/home/coursetask/createCourseTask', params)
  },
  updateCourseTask: params => {
    return service.post('/home/coursetask/updateCourseTask', params)
  },
  getCourseTask: params => {
    return service.get('/home/coursetask/getCourseTask', {params: params})
  },
  getCourseTaskList: params => {
    return service.get('/home/coursetask/getCourseTaskList', {params: params})
  },
  updateCourseTaskStatus: params => {
    return service.post('/home/coursetask/updateCourseTaskStatus', params)
  },
  getCourseStudy: params => {
    return service.get('/home/coursestudy/getCourseStudy', {params: params})
  },
  getCourseStudyList: params => {
    return service.get('/home/coursestudy/getCourseStudyList', {params: params})
  },
  updateCourseStudyStatus: params => {
    return service.post('/home/coursestudy/updateCourseStudyStatus', params)
  },
  getCourseStudyTask: params => {
    return service.get('/home/coursestudytask/getCourseStudyTask', {params: params})
  },
  getCourseStudyTaskList: params => {
    return service.get('/home/coursestudytask/getCourseStudyTaskList', {params: params})
  },
  updateCourseStudyTaskStatus: params => {
    return service.post('/home/coursestudytask/updateCourseStudyTaskStatus', params)
  },
  updateQuestion: params => {
    return service.post('/home/question/updateQuestion', params)
  },
  getQuestion: params => {
    return service.get('/home/question/getQuestion', {params: params})
  },
  getQuestionList: params => {
    return service.get('/home/question/getQuestionList', {params: params})
  },
  updateQuestionStatus: params => {
    return service.post('/home/question/updateQuestionStatus', params)
  },
  updateQuestionWeight: params => {
    return service.post('/home/question/updateQuestionWeight', params)
  },
  delQuestion: params => {
    return service.post('/home/question/delQuestion', params)
  },
  aiGenerateQuestion: params => {
    return service.post('/home/question/aiGenerateQuestion', params)
  },
  saveAIQuestion: params => {
    return service.post('/home/question/saveAIQuestion', params)
  },
  createQuestionBankCategory: params => {
    return service.post('/home/questionbankcategory/createQuestionBankCategory', params)
  },
  updateQuestionBankCategory: params => {
    return service.post('/home/questionbankcategory/updateQuestionBankCategory', params)
  },
  getQuestionBankCategory: params => {
    return service.get('/home/questionbankcategory/getQuestionBankCategory', {params: params})
  },
  getQuestionBankCategoryList: params => {
    return service.get('/home/questionbankcategory/getQuestionBankCategoryList', {params: params})
  },
  updateQuestionBank: params => {
    return service.post('/home/questionbank/updateQuestionBank', params)
  },
  getQuestionBank: params => {
    return service.get('/home/questionbank/getQuestionBank', {params: params})
  },
  getQuestionBankList: params => {
    return service.get('/home/questionbank/getQuestionBankList', {params: params})
  },
  updateQuestionBankStatus: params => {
    return service.post('/home/questionbank/updateQuestionBankStatus', params)
  },
  getQuestionBankStudy: params => {
    return service.get('/home/questionbankstudy/getQuestionBankStudy', {params: params})
  },
  getQuestionBankStudyList: params => {
    return service.get('/home/questionbankstudy/getQuestionBankStudyList', {params: params})
  },
  updateQuestionBankStudyStatus: params => {
    return service.post('/home/questionbankstudy/updateQuestionBankStudyStatus', params)
  },
  getQuestionTotalScore: params => {
    return service.get('/home/questionscore/getQuestionTotalScore', {params: params})
  },
  getQuestionTotalScoreList: params => {
    return service.get('/home/questionscore/getQuestionTotalScoreList', {params: params})
  },
  getQuestionCorrection: params => {
    return service.get('/home/questioncorrection/getQuestionCorrection', {params: params})
  },
  getQuestionCorrectionList: params => {
    return service.get('/home/questioncorrection/getQuestionCorrectionList', {params: params})
  },
  updateQuestionCorrection: params => {
    return service.post('/home/questioncorrection/updateQuestionCorrection', params)
  },
  delQuestionCorrection: params => {
    return service.post('/home/questioncorrection/delQuestionCorrection', params)
  },
  updateExam: params => {
    return service.post('/home/exam/updateExam', params)
  },
  getExam: params => {
    return service.get('/home/exam/getExam', {params: params})
  },
  getExamList: params => {
    return service.get('/home/exam/getExamList', {params: params})
  },
  updateExamStatus: params => {
    return service.post('/home/exam/updateExamStatus', params)
  },
  updateExamType: params => {
    return service.post('/home/examtype/updateExamType', params)
  },
  delExamType: params => {
    return service.post('/home/examtype/delExamType', params)
  },
  updateExamTypeWeight: params => {
    return service.post('/home/examtype/updateExamTypeWeight', params)
  },
  getExamType: params => {
    return service.get('/home/examtype/getExamType', {params: params})
  },
  getExamTypeList: params => {
    return service.get('/home/examtype/getExamTypeList', {params: params})
  },
  updateExamQuestion: params => {
    return service.post('/home/examquestion/updateExamQuestion', params)
  },
  delExamQuestion: params => {
    return service.post('/home/examquestion/delExamQuestion', params)
  },
  updateExamQuestionScore: params => {
    return service.post('/home/examquestion/updateExamQuestionScore', params)
  },
  updateExamQuestionWeight: params => {
    return service.post('/home/examquestion/updateExamQuestionWeight', params)
  },
  getExamQuestion: params => {
    return service.get('/home/examquestion/getExamQuestion', {params: params})
  },
  getExamQuestionList: params => {
    return service.get('/home/examquestion/getExamQuestionList', {params: params})
  },
  getRegOrderList: params => {
    return service.get('/home/regorder/getRegOrderList', {params: params})
  },
  getRegOrder: params => {
    return service.get('/home/regorder/getRegOrder', {params: params})
  },
  closeRegOrder: params => {
    return service.post('/home/regorder/closeRegOrder', params)
  },
  getScorePackageList: params => {
    return service.get('/home/scorepackage/getScorePackageList', {params: params})
  },
  getScorePackage: params => {
    return service.get('/home/scorepackage/getScorePackage', {params: params})
  },
  createScorePackage: params => {
    return service.post('/home/scorepackage/createScorePackage', params)
  },
  updateScorePackage: params => {
    return service.post('/home/scorepackage/updateScorePackage', params)
  },
  updateScorePackageStatus: params => {
    return service.post('/home/scorepackage/updateScorePackageStatus', params)
  }
  /**
   * API demo
   *
   * getAPI: (params) => {
   *    getConfig.params = params.params
   *    return axios.get('xxxx.do', getConfig)
   * }
   *
   * postAPI: (params) => {
   *     return axios.post('xxxx.do', params, postConfig)
   * }
   */

}
